import { makeRequest, CommonRequestOptions } from '../../makeRequest';
import { createErrorMessageTypeGuard } from '../../createErrorMessageTypeGuard';

export const USER_STATUSES = ['active', 'disabled'] as const;

export type UserStatus = (typeof USER_STATUSES)[number];

export type editMultipleUsersStatusOptions = CommonRequestOptions & {
   userids: number[];
   status: UserStatus;
};

export async function editMultipleUsersStatus({
   userids,
   status,
   ...common
}: editMultipleUsersStatusOptions): Promise<void> {
   return makeRequest('put', 'users/manage/status', {
      ...common,
      body: {
         userids: userids,
         status: status,
      },
   });
}

export type EditMultipleUsersStatusErrorCode =
   | 'user_manage.edit_user_status.user_is_self'
   | 'user_manage.edit_user_status.invalid_user'
   | 'user_manage.edit_user_status.max_privileged_users'
   | 'user_manage.edit_user_status.max_standard_user';

editMultipleUsersStatus.errorMessages =
   createErrorMessageTypeGuard<EditMultipleUsersStatusErrorCode>();
